module.exports = __webpack_public_path__ + "assets/img/046201.399ea671.png";